export function fetchParticipant(identify) {
    return fetch(process.env.VUE_APP_API_ORIGIN + '/api/participantByIdentify/' + identify, {
        method: 'GET',
    });
}
